<template>
	<div class="shopCar px16 layui-layout layui-layout-admin" style="background:#fff;overflow-y:auto;max-height:100%;" v-show='show'>
		<div class="layui-header al_itm" style="background:#fff;">
			<div class="px18 al_itm" style="color:#000;margin-left:20px;">
				<i @click="back" class="layui-icon-left layui-icon px20 pointer" style="margin-right:20px;"></i>订单详情
			</div>
		</div>
		<div>
			<div class="f_col px16" style="padding:20px 30px 0;">
				<span style="margin-bottom: 20px;">订单编号 {{order_info.order_num}}</span>
				<div style="margin-bottom:20px;">
					订单状态
					<span id="status1" class="status_text" v-if="order_info.status == 3 && order_info.sales_status == 1">工程师返工</span>
					<span id="status1" class="status_text" v-else-if="order_info.status == 6 && order_info.sales_status == 2">工厂返工</span>
					<span :id="'status'+order_info.status" class="status_text" v-else>{{order_info.status_text}}</span>
					<span v-if='is_c_confirm == 3' style="color: #FF0000;margin-left: 10px;">工程文件有误,请修改后重新上传！</span>
					<span class="layui-btn layui-btn-radius layui-btn-sm afterSale" v-if="evaluate && order_info.is_add_label == 0" @click="onEvaluate">VIP客户制程墙</span>
				</div>
				<span style="margin-bottom:20px;">交付类型 <span class="mon_color">{{order_info.is_fast_text}}</span></span>
				<span v-if='order_info.status == 3 && order_info.sales_status != 1' style="margin-bottom:20px;">交付倒计时 <span class="mon_color" v-if='overtime == 0'>{{count_down}}</span><span class="mon_color" style="color: #FF0000;" v-else>超时</span></span>
			</div>
			<div class="progress">
				<div class="zt_color title" style="padding:8px 30px;color:#fff;">订单进度</div>
				<ul class="layui-timeline" style="padding:20px 30px;">
					<li class="layui-timeline-item" v-for="(item,i) in order_progress">
						<i class="layui-icon layui-timeline-axis zt_txt_color px20">&#xe617;</i>
						<div class="layui-timeline-content layui-text">
							<div class="layui-timeline-title" style="display: flex;">
								<div class="px16">{{item.title}}</div>
								<div class="px14 margin_l10">{{item.time_txt}}</div>
								<div v-if='i == 0' @click="onGouTong" class="px16 zt_txt_color margin_l10 pointer goutong"><i class="layui-icon">&#xe611;</i>&nbsp;&nbsp;沟通</div>
								<div v-if='i == 1 && (is_c_confirm == 0 || is_c_confirm == 3) && order_info.sales_status != 1 && order_info.sales_status != 2' @click="onComplete" class="layui-btn layui-btn-radius layui-btn-sm btn1" style="margin: -5px 0 0 15px;">完工</div>
								<!--工程师超时-->
								<div v-if='i == 2 && timeline.is_e_overtime == 1' style="margin: 0 0 0 15px;color: #FF494C;">超时</div>
								<div v-if='i == 2 && timeline.is_e_overtime == 1 && timeline.is_appeal == 0' @click="onAppeal" class="layui-btn layui-btn-radius layui-btn-sm btn2" style="margin: -5px 0 0 15px;">申诉</div>
								<div v-if='i == 2 && timeline.is_e_overtime == 1 && timeline.is_appeal == 1' class="layui-btn layui-btn-radius layui-btn-sm btn3" style="margin: -5px 0 0 15px;">已申诉</div>
								<div v-if="item.title == '工程师返工' && is_c_confirm == 3 && !timeline.e_rework_finish_time" @click="onComplete2" class="layui-btn layui-btn-radius layui-btn-sm btn1" style="margin: -5px 0 0 15px;">完工</div>
							</div>
							<div class="file-list">
								<div class="file-item" v-if="i == 2 && is_c_confirm == 3 && order_info.sales_status != 1 && order_info.sales_status != 2" v-for='(pdf,j) in other_make'>
									<a class="links" :href="pdf.e_update_file" v-if="pdf.e_update_file_status == 3" target="_blank">工程文件{{j+1}}完成版.pdf</a>
								</div>
								<p v-if="item.title == '工程师返工' && is_c_confirm == 3 && order_info.sales_reason" style="max-width: 70%;">原因：{{order_info.sales_reason}}</p>
								<div class="file-item" v-if="item.title == '工程师返工完成' && is_c_confirm == 3" v-for='(pdf,j) in other_make'>
									<a class="links" :href="pdf.e_update_file" v-if="pdf.e_update_file_status == 3" target="_blank">工程文件{{j+1}}完成版.pdf</a>
								</div>
							</div>
						</div>
					</li>
				</ul>
			</div>
			<div v-if='mesh_attr!=[] && mesh_attr[0]'>
				<div class="zt_color title" style="padding:8px 30px;color:#fff;">钢网规格</div>
				<table class="layui-table align_center orBoxs">
					<thead>
						<tr class="white">
							<th class="align_center">序号</th>
							<th class="align_center">钢片规格</th>
							<th class="align_center">钢片有效印刷面积</th>
							<th class="align_center">数量</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,i) in mesh_attr" :key="i">
							<td>{{i+1}}</td>
							<td>{{item.attr_title}}</td>
							<td>{{item.use_title}}</td>
							<td>{{craft_demand[i].buy_num}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div>
				<div class="zt_color title" style="padding:8px 30px;color:#fff;">工艺要求</div>
				<table class="layui-table align_center orBoxs">
					<thead>
						<tr class="white">
							<th class="align_center">序号</th>
							<th class="align_center">制作要求</th>
							<th class="align_center">交付类型</th>
							<th class="align_center">激光打标</th>
							<th class="align_center">钢网工艺</th>
							<th class="align_center">制作工艺</th>
							<th class="align_center">钢片厚度</th>
							<th class="align_center">Mark基准点</th>
							<th class="align_center">排版方式</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,i) in craft_demand" :key="i">
							<td>{{i+1}}</td>
							<td>{{item.make_demand_text}}</td>
							<td>{{item.is_fast_text}}</td>
							<td>{{item.laser_marking_text}}</td>
							<td>{{item.mesh_purpose_text}}</td>
							<td>{{item.mark_craft_text}}</td>
							<td>{{item.thick_num_text}}</td>
							<td>{{item.mark_point_text}}</td>
							<td>{{item.compose_type_text}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div>
				<div class="zt_color title">CHIP开孔要求</div>
				<table class="layui-table align_center orBoxs">
					<colgroup>
						<col width="200">
						<col>
						<col>
						<col>
						<col>
					</colgroup>
					<thead>
						<tr class="white">
							<th class="align_center">序号</th>
							<th class="align_center">开孔工艺</th>
							<th class="align_center">开孔类型</th>
							<th class="align_center">开孔方案</th>
							<th class="align_center">防锡珠类型</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,i) in open_demand" :key="i">
							<td>{{i+1}}</td>
							<td>{{item.mesh_type == 1 ? '锡膏工艺' : '红胶工艺'}}</td>
							<td>{{item.mesh_type == 2 ? '' : item.hole}}</td>
							<td class="align_center">{{item.solder_hole_type_fa}}</td>
							<td>{{item.hole_type}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-if="hideICBGAPAD">
				<div class="zt_color title">IC集成电路开孔要求</div>
				<table class="layui-table align_center orBoxs">
					<colgroup>
						<col width="200">
						<col>
						<col>
						<col>
					</colgroup>
					<thead>
						<tr class="white">
							<th class="align_center">序号</th>
							<th class="align_center">开孔方案</th>
							<th class="align_center">开孔宽度</th>
							<th class="align_center">开孔形状</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,i) in craft_demand" :key="i" v-if="open_demand[i].mesh_type == 1">
							<td>{{i+1}}</td>
							<td>{{item.ic_open_ask_text}}</td>
							<td>{{item.ic_open_ask_one_text}}</td>
							<td>{{item.ic_open_shape_text}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-if="hideICBGAPAD">
				<div class="zt_color title">BGA封装开孔要求</div>
				<table class="layui-table align_center orBoxs">
					<colgroup>
						<col width="200">
						<col>
						<col>
						<col>
					</colgroup>
					<thead>
						<tr class="white">
							<th class="align_center">序号</th>
							<th class="align_center">开孔方案</th>
							<th class="align_center">开孔直径</th>
							<th class="align_center">开孔形状</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,i) in craft_demand" :key="i" v-if="open_demand[i].mesh_type == 1">
							<td>{{i+1}}</td>
							<td>{{item.bga_open_ask_text}}</td>
							<td>{{item.bga_open_ask_one_text}}</td>
							<td>{{item.bga_open_shape_text}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-if="hideICBGAPAD">
				<div class="zt_color title">散热PAD(接地焊盘)</div>
				<table class="layui-table align_center orBoxs">
					<colgroup>
						<col width="200">
						<col>
						<col>
					</colgroup>
					<thead>
						<tr class="white">
							<th class="align_center">序号</th>
							<th class="align_center">开孔形状</th>
							<th class="align_center">开孔面积</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,i) in craft_demand" :key="i" v-if="open_demand[i].mesh_type == 1">
							<td>{{i + 1}}</td>
							<td>{{item.pad_open_shape_text}}</td>
							<td>{{item.pad_open_area_text}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-if="is_c_confirm != 3">
				<div class="zt_color" style="padding:8px 30px;color:#fff;">其他制作要求和工程文件</div>
				<table class="layui-table align_center orBoxs">
					<colgroup>
						<col width="10%" />
						<col width="20%" />
						<col />
						<col width="25%" />
					</colgroup>
					<thead>
						<tr class="white">
							<th class="align_center">序号</th>
							<th class="align_center">工程文件</th>
							<th class="align_center">其他要求说明</th>
							<th class="align_center">上传工程文件</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,i) in other_make" :key="i">
							<td>{{i+1}}</td>
							<td class="d_line pointer zt_txt_color">
								<a :href="item.pdf_file" class="lines">工程文件</a>
								<a :href="item.pdf_file" class="downloadBtn">下载</a>
							</td>
							<td>{{item.message ? item.message : '无'}}</td>
							<td>
								<a :href="item.e_pdf_file" class="lines underline" v-if="item.e_pdf_file">工程文件{{i+1}}完成版</a>
								<a :href="item.e_pdf_file" class="downloadBtn" v-if="item.e_pdf_file">下载</a>
								<button type="button" class="layui-btn upload_zip zt_color" @click="uploadIndexZIP(i)" v-if="order_info.status == 3"><i class="layui-icon">&#xe67c;</i>上传文件</button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-if="order_info.status == 3 && is_c_confirm != 3">
				<div class="zt_color title" style="padding:8px 30px;color:#fff;">回传给客户确认的PDF文件</div>
				<table class="layui-table align_center orBoxs">
					<colgroup>
						<col width="10%" />
						<col />
					</colgroup>
					<thead>
						<tr class="white">
							<th class="align_center">序号</th>
							<th class="align_center">上传文件</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,i) in other_make" :key="i">
							<td style="width:10%;">{{i+1}}</td>
							<td>
								<a :href="item.e_update_file" class="lines underline" v-if="item.e_update_file" target="_blank">工程文件{{i+1}}完成版</a>
								<a :href="item.e_update_file" class="downloadBtn" v-if="item.e_update_file" target="_blank">下载</a>
								<button type="button" class="layui-btn upload_pdf zt_color" @click="uploadIndexPDF(i)" v-if="item.handle_demand == 2"><i class="layui-icon">&#xe67c;</i>上传文件</button>
								<span v-else>无需验证PDF文件</span>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<!--*******************重新上传文件************************-->
			<div v-if="is_c_confirm == 3">
				<div class="zt_color title" style="padding:8px 30px;color:#fff;">其他制作要求和工程文件</div>
				<table class="layui-table align_center orBoxs">
					<colgroup>
						<col width="10%" />
						<col width="20%" />
						<col />
						<col width="25%" />
					</colgroup>
					<thead>
						<tr class="white">
							<th class="align_center">序号</th>
							<th class="align_center">工程文件</th>
							<th class="align_center">其他要求说明</th>
							<th class="align_center">上传工程文件</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,i) in other_make" :key="i">
							<td>{{i+1}}</td>
							<td class="d_line pointer zt_txt_color">
								<a :href="item.pdf_file" class="lines">工程文件</a>
								<a :href="item.pdf_file" class="downloadBtn">下载</a>
							</td>
							<td>{{item.message ? item.message : '无'}}</td>
							<td>
								<a :href="item.e_pdf_file" class="lines underline" v-if="item.e_pdf_file">工程文件{{i+1}}完成版</a>
								<a :href="item.e_pdf_file" class="downloadBtn" v-if="item.e_pdf_file">下载</a>
								<button type="button" class="layui-btn upload_zip2 zt_color" @click="uploadIndexZIP(i)"><i class="layui-icon">&#xe67c;</i>重新上传</button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-if="is_c_confirm == 3" id="upload-box">
				<div class="zt_color title" style="padding:8px 30px;color:#fff;">回传给客户确认的PDF文件</div>
				<table class="layui-table align_center orBoxs">
					<colgroup>
						<col width="10%" />
						<col />
						<col width="25%" />
					</colgroup>
					<thead>
						<tr class="white">
							<th class="align_center">序号</th>
							<th class="align_center">原因</th>
							<th class="align_center">上传文件</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,i) in other_make" :key="i">
							<td style="width:10%;">{{i+1}}</td>
							<td>
								<span v-if='item.handle_demand == 2 && (item.e_update_file_status == 3 || item.e_update_file_status == 4)'>{{item.reason}}</span>
							</td>
							<td>
								<span v-if="item.handle_demand == 1">无需验证PDF文件</span>
								<a :href="item.e_update_file" class="lines underline" v-if="item.handle_demand == 2" target="_blank">工程文件{{i+1}}完成版</a>
								<button type="button" class="layui-btn upload_pdf2 zt_color" v-if="item.handle_demand == 2 && (item.e_update_file_status == 3 || item.e_update_file_status == 4)" @click="uploadIndexPDF(i)"><i class="layui-icon">&#xe67c;</i>重新上传</button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<!--弹出层-->
		<div class="appeal" style="display: none;">
			<h3>提交申诉</h3>
			<textarea maxlength="120" placeholder="输入申诉理由" v-model="appeal"></textarea>
		</div>
		<div id="complete" style="display: none;">
			<h3>钢网切割资料总孔数</h3>
			<div class="layui-form" lay-filter='formTest'>
				<p style="font-size: 14px;color: red;">*请根据实际情况选择</p>
				<div class="layui-form-item">
					<div class="checkbox_box" v-for='(item,index) in hole'>
						<div style="display: flex;align-items: center;justify-content: space-between;height: 42px;">
							<input class="checkbox" type="checkbox" name="checkbox" :value="item.id" :title="item.title + ' ' + item.add_money + '元'" lay-skin="primary" lay-verify='required' lay-filter="filter">
							<el-input-number v-show="item.check" v-model="item.num" :min="1" size="small" step-strictly style="margin-top: 10px;"></el-input-number>
						</div>
					</div>
				</div>
				<div class="layui-form-item">
					<input class="layui-input" onkeyup="value=value.replace(/[^\d]/g,'')" name="number" v-model="hole_message" maxlength="8" required lay-verify="required" placeholder="请输入实际设计孔数">
				</div>
				<div class="layui-form-item f_row jc_ct">
					<button class="layui-btn zt_color" lay-submit lay-filter="submit">确认完成</button>
				</div>
			</div>
		</div>
		<div id="evaluate" style="display: none;">
			<h3 class="evaluate-title">VIP客户制程墙</h3>
			<div class="layui-form" lay-filter='formTest2'>
				<div class="layui-form-item f_row" style="width: 100%;">
					<div class="label" style="line-height: 34px;">制程标签：</div>
					<div style="flex: 1; display: flex;flex-wrap: wrap;">
						<input class="checkbox" v-for="(item,i) in label" type="checkbox" name="label" :title="item.title" :value="item.id">
					</div>
				</div>
				<div class="layui-form-item f_row jc_ct" style="width: 100%;">
					<button class="layui-btn zt_color" lay-submit lay-filter="submit2">提交</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				show: false,
				evaluate: false,
				order_num: '',
				is_c_confirm: 0, //工程文件是否不通过
				hole: [], //切割孔数价格列表
				order_info: [], //订单状态信息
				order_progress: [], //进度信息
				mesh_attr: [], //规格信息
				take_info: [], //联系人信息
				express_info: [], //快递信息
				craft_demand: [], //工艺要求
				open_demand: [], //开孔要求
				other_make: [], //其他工程文件
				timeline: '',
				dscModel: false,
				showClass: 1,
				content: '',
				table: '',
				forms: '',
				layers: '',
				uploads: '',
				txtList: [],
				indexZIP: '',
				indexPDF: '',
				appeal: '', //申诉理由
				ct: '',
				overtime: 0,
				count_down: '',
				hideICBGAPAD: true,
				label: [],
				numbers: '',
				show_num: false,
				hole_message: '',
				max: 0
			}
		},
		created() {
			let _this = this;
			api.getHoleList({}).then((res) => { // 获取切割孔数列表
				res.data.forEach((val, ind) => {
					val.check = false;
					val.num = 1
				})
				_this.hole = res.data;
			})
			api.getLabelList({}).then((res) => { // 获取评价标签列表
				_this.label = res.data.list;
			})
		},
		mounted() {
			let _this = this;
			layui.use(['table', 'form', 'layer', 'upload'], () => {
				this.table = layui.table;
				this.forms = layui.form;
				this.layers = layui.layer;
				this.uploads = layui.upload;
				this.forms.render();
				this.order_num = this.$route.query.id;
				if(this.order_num) {
					this.getData(this.order_num);
				} else {
					this.$router.replace({
						path: '/myOrder'
					})
				}
				this.forms.on('submit(submit)', function(data) {
					if(!data.field.checkbox) {
						layer.msg('请选择孔数', {
							icon: 2,
							anim: 6
						})
						return false;
					}
					if(!data.field.number) {
						layer.msg('请输入实际孔数', {
							icon: 2,
							anim: 6
						})
						return false;
					}
					_this.finishOrder();
				});

				this.forms.on('checkbox(filter)', function(data) {
					_this.hole.forEach((val) => {
						if(val.id == data.value) {
							val.check = data.elem.checked;
						}
					})
				});

				this.forms.on('submit(submit2)', function(data) {
					let arr = []
					for(let i = 0; i < $('.checkbox').length; i++) {
						if($('.checkbox').eq(i).prop('checked')) {
							arr.push($('.checkbox').eq(i).val());
						}
					}
					if(arr.length == 0) {
						layer.msg('请选择标签', {
							icon: 2,
							anim: 6
						})
						return false;
					}
					if(arr.length > 5) {
						layer.msg('最多只能选择5个标签', {
							icon: 2,
							anim: 6
						})
						return false;
					}
					api.addCompanyLabel({
						token: _this.getCookie('token'),
						company_id: _this.order_info.company_id,
						label_id: arr.join(','),
						order_id: _this.order_info.order_id,
						order_num: _this.order_info.order_num
					}).then((res) => {
						if(res.code == 1) {
							layer.closeAll();
							layer.msg('添加成功', {
								icon: 1,
								anim: 5
							})
							_this.getData(_this.order_num);
						} else {
							layer.msg(res.msg, {
								icon: 2,
								anim: 6
							})
						}
					})
				});
			});
		},
		methods: {
			onEvaluate() { //评价
				let _this = this;
				layer.open({
					type: 1,
					title: false,
					content: $('#evaluate'),
					shade: 0.3,
					resize: false,
					area: '600px',
					success: function() {
						_this.forms.render();
						_this.getData(_this.order_num);
					},
					cancel: function() {
						layer.closeAll();
					}
				});
			},
			back() {
				this.$router.go(-1);
			},
			onComplete() { //完成
				let _this = this;
				this.forms.render();
				layer.open({
					type: 1,
					title: false,
					content: $('#complete'),
					shade: 0.3,
					resize: false,
					area: '460px',
					cancel: function() {
						_this.forms.render();
						layer.closeAll();
					}
				});
			},
			finishOrder() {
				layer.closeAll();
				layer.msg('加载中', {
					icon: 16,
					shade: 0.01,
				});
				let _this = this;
				let order_attr_id = [];
				for(let i = 0; i < this.other_make.length; i++) {
					order_attr_id.push(this.other_make[i].order_attr_id)
				}
				let hole_id = [];
				let add_num = [];
				let max = 0;
				for(let i = 0; i < this.hole.length; i++) {
					if(this.hole[i].check && this.hole[i].num > 0) {
						hole_id.push(this.hole[i].id);
						add_num.push(this.hole[i].num);
						max += this.hole[i].num;
					}
				}
				if(this.max < max) {
					layer.msg("所选数量大于实际数量", {
						icon: 2,
						anim: 6
					})
					return false;
				}
				order_attr_id = order_attr_id.join(',');
				hole_id = hole_id.join(',');
				add_num = add_num.join(',');

				api.finishOrder({ //工程师完成订单
					token: this.getCookie('token'),
					order_num: this.order_info.order_num,
					order_attr_id: order_attr_id,
					hole_id: hole_id,
					add_num: add_num,
					hole_message: this.hole_message,
				}).then((res1) => {
					if(res1.code == 1) {
						layer.closeAll();
						_this.getData(_this.order_info.order_num);
					} else {
						layer.msg(res1.msg, {
							icon: 2,
							anim: 6
						})
					}
				})
			},
			onComplete2() { //返工完成
				let _this = this;
				layer.open({
					type: 0,
					title: "提示",
					content: '是否确认上传的文件无误？',
					btn: ['确认', '取消'],
					btnAlign: 'c',
					shade: 0.3,
					skin: 'demo-class',
					resize: false,
					area: '340px',
					yes: function(index, layero) {
						let order_attr_id = [];
						for(let i = 0; i < _this.other_make.length; i++) {
							order_attr_id.push(_this.other_make[i].order_attr_id)
						}
						order_attr_id = order_attr_id.join(',');
						api.finishOrder({ //工程师完成订单
							token: _this.getCookie('token'),
							order_num: _this.order_info.order_num,
							order_attr_id: order_attr_id
						}).then((res1) => {
							if(res1.code == 1) {
								layer.closeAll();
								_this.getData(_this.order_info.order_num);
							} else {
								layer.msg(res1.msg, {
									icon: 2,
									anim: 6
								})
							}
						})
					},
					btn2: function(index, layero) {
						layer.closeAll();
					},
					cancel: function() {
						layer.closeAll();
					}
				});
			},
			getData(order_num) {
				let _this = this;
				api.getOrderDetail({
					token: this.getCookie('token'),
					order_num: order_num,
					type: 2,
				}).then((res) => {
					if(res.code == 1) {
						this.show = true;
						this.order_info = res.data.order_info;
						this.order_info.time = this.getTimes(res.data.order_info.createtime);
						res.data.craft_demand.forEach(function(val) {
							_this.max += val.buy_num
						})
						this.mesh_attr = res.data.mesh_attr;
						this.take_info = res.data.take_info;
						this.express_info = res.data.express_info;
						this.craft_demand = res.data.craft_demand;
						this.open_demand = res.data.open_demand;
						this.other_make = res.data.other_make;
						this.timeline = res.data.order_progress;
						this.getOrderProgress(this.order_num, res.data.order_info.status);
						this.is_c_confirm = res.data.order_progress.is_c_confirm; //判断是否有设计有误的文件存在
						this.onHide();
						if(this.is_c_confirm == 3) {
							setTimeout(() => {
								this.uploadZIP2();
								this.uploadPDF2();
							}, 300)
						} else {
							setTimeout(() => {
								this.uploadZIP();
								this.uploadPDF();
							}, 300)
						}
					} else {
						layer.msg(res.msg, {
							icon: 2,
							anim: 6
						})
					}
				})
			},
			onHide() {
				if(this.open_demand.length == 1 && this.open_demand[0].mesh_type == 2) {
					this.hideICBGAPAD = false;
				} else if(this.open_demand.length > 1) {
					let hide = false;
					for(let i = 0; i < this.open_demand.length; i++) {
						if(this.open_demand[i].mesh_type == 1) {
							hide = true;
						}
					}
					this.hideICBGAPAD = hide;
				}
			},
			getOrderProgress(order_num, status) {
				let _this = this;
				api.getOrderProgress({
					token: _this.getCookie('token'),
					order_num: _this.order_info.order_num,
					type: 2
				}).then((res) => {
					if(res.code == 1) {
						if(res.data.e_finish_order_time) {
							_this.evaluate = true;
						}
						_this.orderProgress(res.data, status);
					} else {
						layer.msg(res.msg, {
							icon: 2,
							anim: 6
						})
					}
				})
			},
			onAppeal() {
				let _this = this;
				layer.open({
					type: 1,
					title: false,
					content: $('.appeal'),
					btn: ['确认', '取消'],
					shade: 0.3,
					resize: false,
					btnAlign: 'c',
					yes: function(index, layero) {
						if(_this.appeal == '') {
							layer.msg('请输入申诉理由', {
								icon: 2,
								anim: 6
							})
							return false;
						}
						api.eAppealOrder({
							token: _this.getCookie('token'),
							order_num: _this.order_info.order_num,
							appeal_reason: _this.appeal
						}).then((res) => {
							if(res.code == 1) {
								layer.msg('申诉已提交', {
									icon: 1,
									anim: 5
								})
								_this.getData(_this.order_num);
							} else {
								layer.msg(res.msg, {
									icon: 2,
									anim: 6
								})
							}
						})
						_this.appeal = '';
						layer.closeAll();
					},
					btn2: function(index, layero) {
						_this.appeal = '';
						layer.closeAll();
					},
					cancel: function() {
						_this.appeal = '';
						layer.closeAll();
					}
				});
			},
			uploadZIP() {
				let _this = this;
				this.uploads.render({
					elem: '.upload_zip', //绑定元素
					url: 'https://mr.summary88.com/api/Common/OssUploadFile', //上传接口
					accept: 'file',
					number: 1,
					field: 'file',
					exts: 'zip|rar|7z',
					before: function(obj) {
						layer.msg('上传中', {
							icon: 16,
							shade: 0.01
						});
					},
					done: function(res) {
						_this.updateZIP(res.image_url)
					},
					error: function(err) {
						console.log(err) //请求异常回调
					}
				});
			},
			uploadZIP2() {
				let _this = this;
				this.uploads.render({
					elem: '.upload_zip2', //绑定元素
					url: 'https://mr.summary88.com/api/Common/OssUploadFile', //上传接口
					accept: 'file',
					number: 1,
					field: 'file',
					exts: 'zip|rar|7z',
					before: function(obj) {
						layer.msg('上传中', {
							icon: 16,
							shade: 0.01
						});
					},
					done: function(res) {
						_this.updateZIP2(res.image_url)
					},
					error: function(err) {
						console.log(err) //请求异常回调
					}
				});
			},
			uploadPDF() {
				let _this = this;
				this.uploads.render({
					elem: '.upload_pdf', //绑定元素
					url: 'https://mr.summary88.com/api/Common/OssUploadFile', //上传接口
					accept: 'file',
					number: 1,
					field: 'file',
					exts: 'pdf',
					before: function(obj) {
						layer.msg('上传中', {
							icon: 16,
							shade: 0.01
						});
					},
					done: function(res) {
						_this.updatePDF(res.image_url)
					},
					error: function(err) {
						console.log(err) //请求异常回调
					}
				});
			},
			uploadPDF2() {
				let _this = this;
				this.uploads.render({
					elem: '.upload_pdf2', //绑定元素
					url: 'https://mr.summary88.com/api/Common/OssUploadFile', //上传接口
					accept: 'file',
					number: 1,
					field: 'file',
					exts: 'pdf',
					before: function(obj) {
						layer.msg('上传中', {
							icon: 16,
							shade: 0.01
						});
					},
					done: function(res) {
						_this.updatePDF2(res.image_url)
					},
					error: function(err) {
						console.log(err) //请求异常回调
					}
				});
			},
			uploadIndexZIP(index) { //获取点击上传按钮对应的索引值
				this.indexZIP = index;
			},
			uploadIndexPDF(index) { //获取点击上传按钮对应的索引值
				this.indexPDF = index;
			},
			updateZIP(urls) { //上传压缩包
				let _this = this;
				api.saveFileUrl({
					token: _this.getCookie('token'),
					order_num: _this.order_info.order_num,
					order_attr_id: _this.other_make[_this.indexZIP].order_attr_id,
					file_url: urls,
					type: 1,
					file_status: 1,
				}).then((res) => {
					layer.closeAll('loading');
					if(res.code == 1) {
						layer.msg('上传成功', {
							icon: 1,
							anim: 5
						})
						_this.other_make[_this.indexZIP].e_pdf_file = urls;
					} else {
						layer.msg(res.msg, {
							icon: 2,
							anim: 6
						})
					}
				})
			},
			updatePDF(urls) { //上传PDF
				let _this = this;
				api.saveFileUrl({
					token: _this.getCookie('token'),
					order_num: _this.order_info.order_num,
					order_attr_id: _this.other_make[_this.indexPDF].order_attr_id,
					file_url: urls,
					type: 2,
					file_status: 1,
				}).then((res) => {
					layer.closeAll('loading');
					if(res.code == 1) {
						layer.msg('上传成功', {
							icon: 1,
							anim: 5
						})
						_this.other_make[_this.indexPDF].e_update_file = urls;
					} else {
						layer.msg(res.msg, {
							icon: 2,
							anim: 6
						})
					}
				})
			},
			updateZIP2(urls) { //重新上传
				let _this = this;
				api.saveFileUrl({
					token: _this.getCookie('token'),
					order_num: _this.order_info.order_num,
					order_attr_id: _this.other_make[_this.indexZIP].order_attr_id,
					file_url: urls,
					type: 1,
					file_status: 3,
				}).then((res) => {
					layer.closeAll('loading');
					if(res.code == 1) {
						layer.msg('上传成功', {
							icon: 1,
							anim: 5
						})
						_this.other_make[_this.indexPDF].e_update_file = urls;
					} else {
						layer.msg(res.msg, {
							icon: 2,
							anim: 6
						})
					}
				})
			},
			updatePDF2(urls) { //重新上传
				let _this = this;
				api.saveFileUrl({
					token: _this.getCookie('token'),
					order_num: _this.order_info.order_num,
					order_attr_id: _this.other_make[_this.indexPDF].order_attr_id,
					file_url: urls,
					type: 2,
					file_status: 3,
				}).then((res) => {
					layer.closeAll('loading');
					if(res.code == 1) {
						layer.msg('上传成功', {
							icon: 1,
							anim: 5
						})
						_this.other_make[_this.indexPDF].e_update_file = urls;
					} else {
						layer.msg(res.msg, {
							icon: 2,
							anim: 6
						})
					}
				})
			},
			orderProgress(progress, status) {
				let _this = this;
				let obj = [];
				if(progress.createtime) {
					obj.push({
						title: '下单',
						time: progress.createtime,
						time_txt: this.getTimes(progress.createtime),
					})
				}
				if(progress.e_get_order_time) {
					obj.push({
						title: '工程师接单',
						time: progress.e_get_order_time,
						time_txt: this.getTimes(progress.e_get_order_time),
					})
				}
				if(status == 3) {
					this.ct = '';
					clearInterval(this.ct);
					this.ct = setInterval(() => {
						_this.getCountDown(progress.e_get_order_time + 60 * 120);
					}, 1000)
				}
				if(progress.e_finish_order_time) {
					obj.push({
						title: '工程师完工',
						time: progress.e_finish_order_time,
						time_txt: this.getTimes(progress.e_finish_order_time),
					})
				}
				if(progress.f_get_order_time) {
					obj.push({
						title: '工厂接单',
						time: progress.f_get_order_time,
						time_txt: this.getTimes(progress.f_get_order_time),
					})
				}
				if(progress.f_finish_order_time) {
					obj.push({
						title: '已发货',
						time: progress.f_finish_order_time,
						time_txt: this.getTimes(progress.f_finish_order_time),
					})
				}
				if(progress.f_rep_order_time) {
					obj.push({
						title: '补发',
						time: progress.f_rep_order_time,
						time_txt: this.getTimes(progress.f_rep_order_time),
					})
				}
				if(progress.c_post_sale_time) {
					obj.push({
						title: '客户发起售后',
						time: progress.c_post_sale_time,
						time_txt: this.getTimes(progress.c_post_sale_time),
						color: '#E51C23'
					})
				}
				if(progress.a_get_order_time) {
					obj.push({
						title: '平台客服接入',
						time: progress.a_get_order_time,
						time_txt: this.getTimes(progress.a_get_order_time),
						color: '#1890FF'
					})
				}
				if(progress.e_rework_time) {
					obj.push({
						title: '工程师返工',
						time: progress.e_rework_time,
						time_txt: this.getTimes(progress.e_rework_time),
						color: '#FF9800'
					})
				}
				if(progress.e_rework_finish_time) {
					obj.push({
						title: '工程师返工完成',
						time: progress.e_rework_finish_time,
						time_txt: this.getTimes(progress.e_rework_finish_time),
					})
				}
				if(progress.f_rework_time || progress.f_rework_finish_time) {
					obj.push({
						title: '工厂重新发货',
						time: progress.f_rework_finish_time ? progress.f_rework_finish_time : progress.f_rework_time,
						time_txt: this.getTimes(progress.f_rework_finish_time ? progress.f_rework_finish_time : progress.f_rework_time),
					})
				}
				if(progress.c_finish_order_time && this.order_info.sales_status == 1 && this.order_info.sales_status == 2) {
					obj.push({
						title: '售后完成',
						time: progress.c_finish_order_time,
						time_txt: this.getTimes(progress.c_finish_order_time),
					})
				}
				if(progress.c_finish_order_time && this.order_info.sales_status != 1 && this.order_info.sales_status != 2) {
					obj.push({
						title: '订单完成',
						time: progress.c_finish_order_time,
						time_txt: this.getTimes(progress.c_finish_order_time),
					})
				}
				this.order_progress = obj;
			},
			getCountDown(time) { //倒计时
				let _this = this;
				let t = time * 1000 - new Date().getTime();
				if(t < 0) {
					clearInterval(this.ct);
					this.overtime = 1;
				} else {
					let hh = parseInt(t / (60 * 60 * 1000));
					t = t % (60 * 60 * 1000);
					let mm = parseInt(t / (60 * 1000));
					t = t % (60 * 1000);
					let ss = parseInt(t / (1000));
					hh = hh < 10 ? '0' + hh : hh;
					mm = mm < 10 ? '0' + mm : mm;
					ss = ss < 10 ? '0' + ss : ss;
					this.count_down = hh + ':' + mm + ':' + ss;
				}
			},
			onGouTong() {
				this.$router.push({
					path: '/communicate',
					query: {
						order_num: this.order_num,
						id: this.order_info.order_id,
						company_id: this.order_info.company_id
					}
				})
			},
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	#evaluate {
		padding: 0 20px;
	}
	
	#evaluate .evaluate-title {
		font-size: 20px;
		font-weight: bold;
		text-align: center;
		line-height: 50px;
	}
	
	#evaluate .layui-form {
		display: flex;
		flex-wrap: wrap;
	}
	
	#evaluate .layui-form-item .label {
		width: 100px;
		text-align: right;
	}
	
	.afterSale {
		background-color: rgb(63, 81, 181);
	}
	
	#complete {
		width: 400px;
		padding: 0 30px;
	}
	
	#complete h3 {
		font-size: 20px;
		font-weight: bold;
		text-align: center;
		line-height: 50px;
		margin-bottom: 20px;
	}
	
	#complete .checkbox_box {
		margin-bottom: 5px;
	}
	
	.layer {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, 0.3);
		z-index: 10000;
	}
	
	.appeal {
		width: 300px;
		padding: 0 20px;
	}
	
	.appeal h3 {
		font-size: 20px;
		font-weight: bold;
		text-align: center;
		line-height: 50px;
	}
	
	.appeal textarea {
		width: 100% !important;
		border: 1px solid #C9C9C9;
		border-radius: 5px;
		font-size: 14px;
		height: 150px !important;
		resize: none;
		box-sizing: border-box;
		padding: 5px;
	}
	
	.lines {
		color: rgb(72, 118, 255);
	}
	
	.underline {
		text-decoration: underline;
	}
	
	.progress ul li:last-child {
		padding-bottom: 0 !important;
	}
	
	.goutong {
		padding: 4px 8px;
		border: 1px solid;
		border-radius: 15px;
		margin-top: -5px;
	}
	
	.btn1 {
		display: inline-block;
		background: rgb(139, 195, 74);
		min-width: 50px;
		margin-left: 10px;
		margin-top: -5px;
	}
	
	.btn2 {
		display: inline-block;
		background: rgb(255, 152, 0);
		min-width: 50px;
		margin-left: 10px;
		margin-top: -5px;
	}
	
	.btn3 {
		display: inline-block;
		background: rgb(112, 112, 112);
		min-width: 50px;
		margin-left: 10px;
		margin-top: -5px;
	}
	
	.shopCar {
		font-family: SourceHanSansSC;
	}
	
	.sxBox {
		padding: 20px 10% 10px;
	}
	
	.scektsBox {
		position: absolute;
		bottom: 0;
		right: 0;
		width: 100%;
	}
	
	.status_text {
		color: rgba(255, 152, 0, 1);
	}
	
	.title {
		padding: 8px 30px;
		color: #fff;
		border-radius: 5px;
	}
	
	.downloadBtn {
		width: 46px;
		height: 26px;
		line-height: 26px;
		font-size: 12px;
		background: #4876FF;
		color: #FFFFFF;
		display: inline-block;
		text-align: center;
		border-radius: 3px;
		margin-left: 5px;
	}
</style>


// WEBPACK FOOTER //
// src/components/orderDetail.vue